import { Model } from 'types';
import { createSelectField } from './createSelectField';

export const ModelSelectField = createSelectField<Model>('transport/models/', {
  getOptionLabel: ({ title }: Model) => title,
  getOptionValue: ({ id }: Model) => id.toString(),
});
